import { useEffect, useState } from "react";
import { useSearchParams } from "next/navigation";
import {
  ActivitiesRef,
  CategoryRef,
  LanguageRef,
  TagRef,
} from "@/types/components";

export const useActivitiesParseUrl = ({
  categories,
  parseTerm,
  mobilityTags,
  tags,
  languages,
  valuesState,
}: {
  categories: CategoryRef;
  parseTerm: (term: string) => void;
  mobilityTags: TagRef;
  tags: TagRef;
  languages: LanguageRef;
  valuesState: ActivitiesRef;
}) => {
  const searchParms = useSearchParams();
  const [mounted, setMounted] = useState(false);
  const [isParsedCategories, setIsParsedCategories] = useState(false);
  const [isParsedMobilities, setIsParsedMobilities] = useState(false);
  const [isParsedTags, setIsParseTags] = useState(false);
  const [isParsedLangs, setIsParsedLangs] = useState(false);
  const [isParsedMinPrice, setIsParsedMinPrice] = useState(false);
  const [isParsedMaxPrice, setIsParsedMaxPrice] = useState(false);

  useEffect(() => {
    if (isParsedCategories) {
      return;
    }
    if (searchParms.get("categories") && categories.current && mounted) {
      const searchParamsItems = searchParms.get("categories")?.split(",") ?? [];

      categories.current.forEach((item) => {
        const exists = searchParamsItems.find((it) => parseInt(it) === item.id);
        if (exists) {
          item.selected = true;
        }
      });

      for (const it of searchParamsItems) {
        parseTerm(`cat:${it}`);
      }

      setIsParsedCategories(true);
    }
  }, [categories, parseTerm, searchParms, mounted, isParsedCategories]);

  useEffect(() => {
    if (isParsedMobilities) {
      return;
    }
    if (searchParms.get("mobilities") && mobilityTags.current && mounted) {
      const searchParamsItems = searchParms.get("mobilities")?.split(",") ?? [];
      mobilityTags.current.forEach((item) => {
        const exists = searchParamsItems.find((it) => parseInt(it) === item.id);
        if (exists) {
          item.selected = true;
        }
      });

      for (const it of searchParamsItems) {
        parseTerm(`mob:${it}`);
      }

      setIsParsedMobilities(true);
    }
  }, [isParsedMobilities, mobilityTags, mounted, parseTerm, searchParms]);

  useEffect(() => {
    if (isParsedTags) {
      return;
    }
    if (searchParms.get("tags") && tags.current && mounted) {
      const searchParamsItems = searchParms.get("tags")?.split(",") ?? [];
      tags.current.forEach((item) => {
        const exists = searchParamsItems.find((it) => parseInt(it) === item.id);
        if (exists) {
          item.selected = true;
        }
      });

      for (const it of searchParamsItems) {
        parseTerm(`tag:${it}`);
      }

      setIsParseTags(true);
    }
  }, [isParsedTags, mounted, parseTerm, searchParms, tags]);

  useEffect(() => {
    if (isParsedLangs) {
      return;
    }
    if (searchParms.get("langs") && languages.current && mounted) {
      const searchParamsItems = searchParms.get("langs")?.split(",") ?? [];
      languages.current.forEach((item) => {
        const exists = searchParamsItems.find((it) => parseInt(it) === item.id);
        if (exists) {
          item.selected = true;
        }
      });

      valuesState.current.languages = searchParms.get("langs") ?? "";

      setIsParsedLangs(true);
    }
  }, [isParsedLangs, languages, mounted, parseTerm, searchParms, valuesState]);

  useEffect(() => {
    if (isParsedLangs) {
      return;
    }
    if (searchParms.get("langs") && languages.current && mounted) {
      const searchParamsItems = searchParms.get("langs")?.split(",") ?? [];
      languages.current.forEach((item) => {
        const exists = searchParamsItems.find((it) => parseInt(it) === item.id);
        if (exists) {
          item.selected = true;
        }
      });

      valuesState.current.languages = searchParms.get("langs") ?? "";

      setIsParsedLangs(true);
    }
  }, [isParsedLangs, languages, mounted, parseTerm, searchParms, valuesState]);

  useEffect(() => {
    if (isParsedMinPrice) {
      return;
    }
    if (searchParms.get("minPrice") && mounted) {
      const price = parseInt(searchParms.get("minPrice") ?? "0");

      valuesState.current.minPrice = price;

      setIsParsedMinPrice(true);
    }
  }, [isParsedMinPrice, mounted, searchParms, valuesState]);

  useEffect(() => {
    if (isParsedMaxPrice) {
      return;
    }
    if (searchParms.get("maxPrice") && mounted) {
      const price = parseInt(searchParms.get("maxPrice") ?? "0");

      valuesState.current.maxPrice = price;

      setIsParsedMaxPrice(true);
    }
  }, [isParsedMaxPrice, mounted, searchParms, valuesState]);

  useEffect(() => {
    setMounted(true);
  }, []);
};
